
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockApproveDtGrid extends Serenity.EntityGrid<IcStockApproveDtRow, any> {
        protected getColumnsKey() { return IcStockApproveDtColumns.columnsKey; }
        protected getDialogType() { return IcStockApproveDtDialog; }
        protected getIdProperty() { return IcStockApproveDtRow.idProperty; }
        protected getInsertPermission() { return IcStockApproveDtRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockApproveDtRow.localTextPrefix; }
        protected getService() { return IcStockApproveDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();


            return filters;
        }
        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected beforeLoadEntity() {
            let self = this;


        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }
        protected getButtons() {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            buttons.filter(x => x.cssClass = "refresh-button")
            

            return buttons;
        }
        
        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();
            //--set new set of grid columns---
            //--get content width
            //slick-viewport slick-viewport-top slick-viewport-left
            let ele = document.getElementsByClassName("slick-viewport");
            var bordermg = 60;
            var eleWidth = ele.item(0).clientWidth - bordermg * 5;
            var totalcolw = 0;
            //---100,260,600,120,100,220,220 = 1620 = base (wide screen)
            //---1469 - notebook, --1135 when have menu 
            let propItems = this.getPropertyItems();
            let items = this.getColumns();
            items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                totalcolw += pItem.width;

            });
            items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                pItem.resizable = true;
                pItem.width = (eleWidth / totalcolw) * pItem.width;


            });
            let c = this.postProcessColumns(this.propertyItemsToSlickColumns(propItems));
            this.slickGrid.setColumns(c);
            this.slickGrid.resizeCanvas();

          

            return this.slickGrid;
        }
    
    }
}